import { getCookie } from 'cookies-next'
import mixpanel from 'mixpanel-browser'

import { getSubjectFromJwt } from './subject-from-jwt'

const mixpanelTrack = (eventName: string, properties?: object): void => {
  if (typeof window === 'undefined') {
    // mixpanel SDK needs window.document to work
    return
  }

  mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN, {
    api_host: 'https://api-eu.mixpanel.com',
    persistence: 'cookie',
  })

  if (eventName == 'logout') {
    mixpanel.reset()
  }

  if (eventName == 'login') {
    const accessToken = getCookie('access_token')
    const userId = getSubjectFromJwt(accessToken)
    mixpanel.identify(userId)
  }

  if (eventName == 'set_user_data') {
    mixpanel.people.set(properties)
    // people data are sent after identify, so i force an identify
    const accessToken = getCookie('access_token')
    const userId = getSubjectFromJwt(accessToken)
    mixpanel.identify(userId)
    return
  }

  mixpanel.track(eventName, properties)
}

export default mixpanelTrack
